import { httpByCurrentCustomer } from "@/lib/client";

export const getIPRestriction = (): Promise<IPRestriction> => {
  return httpByCurrentCustomer().get("IPAccess").json<IPRestriction>();
};

export const saveIPRestriction = (payload: IPRestriction) => {
  return httpByCurrentCustomer().post("IPAccess", { json: payload });
};

type IPRestriction = {
  enabled: boolean;
  list: string[] | null;
};
